export default __webpack_public_path__ + "static/media/z_cru_jacket.1c6e04ef.jpg";